import React, { useEffect, useRef, useState } from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types';
import StepsLoader from "../steps-loader";
import BaseParagraph from "../../base-components/base-paragraph";
import InputField from "../../base-components/base-input";
import StepFooterAction from "../../base-components/step-footer-action";
import getStep from '../../../helpers/getStep';

const IncomeSourceOther = ({ _step_service, error, step_ID, step_URL, next_step, step_form, setDataToContext, getDataFromContext }) => {

    const form = useRef()
    const data = getDataFromContext(step_ID)
    const [isLoading, setIsLoading] = useState(false)
    const [inputData, setInputData] = useState({ ...data })
    const [isValid, setIsValid] = useState(false)
   
    const getInputValue = (name, value) => {
        setInputData({
            ...inputData,
            [name] : value
        })
        setDataToContext(step_ID, step_URL, "income_source_other", value)
    }

    useEffect(()=> {
        setIsValid(isValidForm())
    }, [inputData])

    useEffect(() => {

        getStep(["income_source_other"]).then(res => {
            console.log("res => ", res)
          res.income_source_other !== "NULL" &&  setInputData({...res})
        })

                   if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
                        pageID: "onboarding",
                        stepSeq: "2",
                        stepName: "financial info:sources of income:specify other",
                        flowType: "sales",
                        flowName: "onboarding",
                        productName: "onboarding",
                        trackMethod: "flow"
                    }
                );
            }


    }, [])

    const action = () => {
         _step_service({step_ID, setIsLoading, next_step})
    }

    const isValidForm = () => {
       return [...form.current.elements].every(element => {
            return element.value !== "" && element.value !== " "
        })
    }
    return (
            <StepsLoader step_ID={step_ID} loading={isLoading}>
                <form ref={form}>
                    <BaseParagraph>
                    <h3>{ t('financial_infos.financial_info_sources_of_income_specify_other.title')}</h3>
                        <InputField
                            label={t('financial_infos.financial_info_sources_of_income_specify_other.label')}
                            value={inputData["income_source_other"] !== "NULL" && inputData["income_source_other"]}
                            name={"income_source_other"}
                            getInputValue={getInputValue}
                            key={"income_source_other"}
                        error={error}
                            max={200}
                        
                        />
               
                    </BaseParagraph>
                </form>
                <StepFooterAction caption={t('general.continue')}  action={action} link={next_step} disabled={!isValid} />
            </StepsLoader>
    )
}

IncomeSourceOther.propTypes = {
    error: PropTypes.array,
    _step_service: PropTypes.func,
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
}

export default IncomeSourceOther